module.exports = __webpack_public_path__ + "img/3_147.a0c11654.png";